"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function camelToHyphen(camelString) {
    return camelString
        .replace(/[A-Z]/g, function (string) { return "-" + string.toLowerCase(); })
        .toLowerCase();
}
exports.default = camelToHyphen;



//////////////////
// WEBPACK FOOTER
// ./node_modules/use-media/lib/utilities/camelToHyphen.js
// module id = 549
// module chunks = 0